<script setup>

import {useGetValidatedFields} from "@/composables/common/useGetValidatedFields";
import MultiSearchDropDown from "@/components/common/input/MultiSearchDropDown.vue";
import StaticTooltip from "@/components/common/other/StaticTooltip.vue";
import API from "@/classes/global/API";
import {useClearCompany} from "@/composables/bookings/useClearCompany";
import {useClearShipperContact} from "@/composables/bookings/useClearShipperContact";
import {useMapShipperAddress} from "@/composables/bookings/useMapShipperAddress";
import {useClearConsigneeContact} from "@/composables/bookings/useClearConsigneeContact";
import {useMapConsigneeAddress} from "@/composables/bookings/useMapConsigneeAddress";

const emits = defineEmits(['update:modelValue', 'addNewConsigneeAddress', 'editConsigneeAddress'])

const props = defineProps({

  modelValue: {},
  validationViewModel: {}

})


async function getCompanyDetails(name, section) {

  props.modelValue[section].id = parseInt(name.id);

  useClearCompany('consignee', props, props.validationViewModel);

  let response = await API.getCompanyDetail(name.id)

  if (response) {

    try {

      mapConsigneeAddress(response);

    } catch (error) {

      // TODO Log Error

    }

  }

}

function handleClearCompany(area) {

  useClearCompany(area, props, props.validationViewModel);

}

function mapConsigneeAddress(data) {

  useClearConsigneeContact(props.modelValue);
  useMapConsigneeAddress(data, props.modelValue);

}

</script>

<template>
  <div class="global-address-select">

    <div class="cmp-multi-booking_address-layout">
      <MultiSearchDropDown
          :key="props.modelValue.metaData.consignees"
          :requiredField="useGetValidatedFields( props.modelValue.metaData.validatedFields, 'consigneeName' )"
          :maxLength="50"
          :allowCustomValue="false"
          @select="getCompanyDetails($event, 'consignee')"
          @clear="handleClearCompany('consignee')"
          :selectPrimitiveValue="true"
          :useServerSearch="true"
          searchType="consignee"
          v-model:validation-fail="validationViewModel"
          label="Consignee"
          :label-top="true"
          :label-width="50"
          v-model="props.modelValue.consignee.consigneeName"
          :data-source="props.modelValue.metaData.consignees">
      </MultiSearchDropDown>
      <StaticTooltip :icon="false">
        <template #content>
          <div style="width: 300px;">
            Select a Shipper by typing a Company name or postcode to perform a search. Click here to add
            a new address record, or use a one time address for the booking.
          </div>
        </template>
        <img class="global-icon-button"
             @click="emits('addNewConsigneeAddress')"
             height="22"
             width="22"
             src="@/assets/icons/akar/akar-icons--circle-plus.png">
      </StaticTooltip>
      <StaticTooltip :icon="false">
        <template #content>
          <div style="width: 300px;">
            Edit the Shipper address, you may also create a new Shipper for your records if you have chosen
            to use un saved address information previously.
          </div>
        </template>
        <img class="global-icon-button"
             @click="emits('editConsigneeAddress')"
             v-if="modelValue.consignee.consigneeName"
             height="22" width="22"
             src="@/assets/icons/akar/akar-icons--edit.png">
      </StaticTooltip>
    </div>
    <div class="cmp-multi-booking_address-container">
      <div v-if="modelValue.consignee.id === 0 && modelValue.consignee.consigneeName"
           style="position: absolute; top: 12px; right: 5px">
        <img title="This address is not saved in your system."
             height="16"
             width="16"
             src="@/assets/icons/unsaved.png">
      </div>
      <div class="cmp-multi-booking_selected-address">
        <div v-if="props.modelValue.consignee.consigneeName">
          <div>{{ props.modelValue.consignee.consigneeAddressLine1 }}</div>
          <div>{{ props.modelValue.consignee.consigneeAddressLine2 }}</div>
          <div>{{ props.modelValue.consignee.consigneeCity }}</div>
          <div>{{ props.modelValue.consignee.consigneePostcode }}</div>
          <div>{{ props.modelValue.consignee.consigneeCounty }}</div>
          <div>{{ props.modelValue.consignee.consigneeCountry }}</div>
          <div v-if="props.modelValue.consignee.consigneeVatNumber" class="cmp-multi-booking_address-heading">Vat Number</div>
          <div>{{ props.modelValue.consignee.consigneeVatNumber }}</div>
        </div>
        <div v-if="!props.modelValue.consignee.consigneeName" class="cmp-multi-booking_address-placeholder-wrapper">
          <div style="display:flex; align-items: center">
            <img height="26" width="26" src="@/assets/icons/address-marker.png">
            <span>Address Information</span>
          </div>
          <div class="cmp-multi-booking_address-placeholder cmp-multi-booking_a-p1"></div>
          <div class="cmp-multi-booking_address-placeholder cmp-multi-booking_a-p2"></div>
          <div class="cmp-multi-booking_address-placeholder cmp-multi-booking_a-p3"></div>
          <div class="cmp-multi-booking_address-placeholder cmp-multi-booking_a-p4"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

@import '@/css/booking/multi-booking.scss';

</style>